import { IPage, Page } from './Page';
import { ISection, Section } from './Section';
import { Column, IColumn } from './Column';
import { IText, Text } from './Text';
import { IImage, Image } from './Image';
import { Group, IGroup } from './Group';
import { Button, IButton } from './Button';
import { Divider, IDivider } from './Divider';
import { IWrapper, Wrapper } from './Wrapper';
import { ISpacer, Spacer } from './Spacer';
import { IRaw, Raw } from './Raw';
import { Carousel, ICarousel } from './Carousel';
import { Hero, IHero } from './Hero';
import { Navbar, INavbar } from './Navbar';
import { ISocial, Social } from './Social';
import { Template, ITemplate } from './Template';

import { Accordion, IAccordion } from './Accordion';
import { AccordionElement, IAccordionElement } from './AccordionElement';
import { AccordionTitle, IAccordionTitle } from './AccordionTitle';
import { AccordionText, IAccordionText } from './AccordionText';
import { Table, ITable } from './Table';
import { ListingsBlock, IListingsBlock } from './Listing';
import { SingleListingBlock, ISingleListing } from './SingleListing';
import { UsersBlock, IUsersBlock } from './Users';
import { UsersCriteriaBlock, IUsersCriteriaBlock } from './UsersCriteriaBlock';
import { SingleUserBlock, ISingleUser } from './SingleUser';
import { ListingsCriteriaBlock, ICriteriaBlock } from './CriteriaBlock';
import { CustomListingBlock, ICustomListing } from './CustomListing';
import { SignatureBlock, ISignature } from './Signature';
import { DynamicImageBlock, IDynamicImage } from './DynamicImage';
import { BasicType, LEGACY_RAW_BLOCK_TYPE } from '@core/constants';

export const standardBlocks = {
	[BasicType.PAGE]: Page,
	[BasicType.SECTION]: Section,
	[BasicType.COLUMN]: Column,
	[BasicType.TEXT]: Text,
	[BasicType.IMAGE]: Image,
	[BasicType.GROUP]: Group,
	[BasicType.BUTTON]: Button,
	[BasicType.DIVIDER]: Divider,
	[BasicType.WRAPPER]: Wrapper,
	[BasicType.SPACER]: Spacer,
	[BasicType.RAW]: Raw,
	[LEGACY_RAW_BLOCK_TYPE]: Raw,
	[BasicType.CAROUSEL]: Carousel,
	[BasicType.HERO]: Hero,
	[BasicType.NAVBAR]: Navbar,
	[BasicType.SOCIAL]: Social,

	// spacial block, render string
	[BasicType.TEMPLATE]: Template,

	// TODO:

	[BasicType.ACCORDION]: Accordion,
	[BasicType.ACCORDION_ELEMENT]: AccordionElement,
	[BasicType.ACCORDION_TITLE]: AccordionTitle,
	[BasicType.ACCORDION_TEXT]: AccordionText,

	[BasicType.TABLE]: Table,

	// Always-on custom block (no feature flag). Must be eagerly registered
	// because Column/Group list it as a validParentType — BlockManager's
	// setAutoCompletePath resolves that reference and throws if it's missing.
	[CustomListingBlock.type]: CustomListingBlock,
};

export type {
	IPage,
	ISection,
	IWrapper,
	IColumn,
	IGroup,
	IText,
	ITable,
	IImage,
	IButton,
	IDivider,
	IRaw,
	ISpacer,
	ICarousel,
	IHero,
	ISocial,
	INavbar,
	IAccordion,
	IAccordionElement,
	IAccordionTitle,
	IAccordionText,
	ITemplate,
	IListingsBlock,
	ISingleListing,
	IUsersBlock,
	IUsersCriteriaBlock,
	ISingleUser,
	ICriteriaBlock,
	ISignature,
	IDynamicImage,
	ICustomListing,
};

// Migration readers for the listing bindings — recover the id(s) whether a
// design stores the new reference field or a pre-migration resolved object.
export { getListingsBlockIds } from './Listing';
export { getSingleListingId } from './SingleListing';
export { getCriteriaBlockConfig } from './CriteriaBlock';

export {
	Raw,
	ListingsBlock,
	SingleListingBlock,
	UsersBlock,
	UsersCriteriaBlock,
	SingleUserBlock,
	ListingsCriteriaBlock,
	SignatureBlock,
	DynamicImageBlock,
	CustomListingBlock,
};
